import { Component } from 'shimmer'

import { Vector3, Mesh, BoxBufferGeometry, MeshNormalMaterial } from 'three'
import Noise from 'simplex-noise'

import { Loader } from '@/utils/Loader'

export class Drone extends Component {
  constructor (url, seed) {
    super({name: 'Drone'})

    this.url = url

    this.promise = new Promise(resolve => {
      this.resolve = resolve
    })

    this.promises = []

    this.promises.push(Loader.load(this.url).then(drone => {
      this.drone = drone
      this.add(this.drone)
    }))

    this.noise = new Noise(seed)

    Promise.all(this.promises).then(this.resolve)
  }

  onUpdate ({ elapsed }) {
    if (!this.drone) {return;}

    this.drone.position.x = this.noise.noise2D(0, elapsed * .00002) * .6
    this.drone.position.y = .08 + this.noise.noise2D(1, elapsed * .0001) * .05
    this.drone.position.z = this.noise.noise2D(2, elapsed * .00002) * .6
  }
}